var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyriusLogoPadded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9375 96.2665L128 27.5106V128L71.9375 96.2665Z",
    fill: "url(#paint0_linear_914_2220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9375 59.2441L128 27.5106L71.9375 96.2665V59.2441Z",
    fill: "url(#paint1_linear_914_2220)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.062 59.2441L128 27.5106V90.9776L184.062 59.2441Z",
    fill: "url(#paint2_linear_914_2220)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.063 159.734L128 228.489L128 128L184.063 159.734Z",
    fill: "url(#paint3_linear_914_2220)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.063 196.756L128 228.489L184.063 159.734L184.063 196.756Z",
    fill: "url(#paint4_linear_914_2220)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9375 196.756L128 228.489L128 165.022L71.9375 196.756Z",
    fill: "url(#paint5_linear_914_2220)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_914_2220",
    x1: 128,
    y1: 27.5106,
    x2: 71.9375,
    y2: 27.5106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_914_2220",
    x1: 91.5065,
    y1: 72.9953,
    x2: 71.9375,
    y2: 58.7152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_914_2220",
    x1: 184.062,
    y1: 59.2441,
    x2: 128,
    y2: 59.2441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FF02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_914_2220",
    x1: 128,
    y1: 228.489,
    x2: 184.063,
    y2: 228.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1255AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_914_2220",
    x1: 164.494,
    y1: 183.005,
    x2: 184.063,
    y2: 197.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1762C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_914_2220",
    x1: 71.9375,
    y1: 196.756,
    x2: 128,
    y2: 196.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyriusLogoPadded);
export default __webpack_public_path__ + "static/media/syrius-logo-padded.9f7d47b3145331160402384e14dd9ae6.svg";
export { ForwardRef as ReactComponent };